angular.module('components.createResellerOrderArticlesAmount', [])
    .component('createResellerOrderArticlesAmount', {
        templateUrl: 'main/resellerorder/resellerordermodify/components/articlelist_amount.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            resellerOrder: '=',
            disabled: '<',
            onArticleSelected: '&',
            onLineItemChanged: '&'
        },
        controller: controller
    });

// @ngInject
function controller($scope, $translate, confirmationDialogService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    //Properties
    vm.lineItemsGroupedByArticle = [];

    //Methods
    vm.viewOrderArticle = viewOrderArticle;
    vm.absolute = absolute;
    vm.groupBy = groupBy;
    vm.saveLineItem = saveLineItem;
    vm.canModifyLineItem = canModifyLineItem;
    vm.getVariant1s = getVariant1s;
    vm.getVariant2s = getVariant2s;
    vm.toggleExpandAll = toggleExpandAll;
    vm.canClearRow = canClearRow;
    vm.confirmClearRow = confirmClearRow;
    vm.removeArticleFromOrder = removeArticleFromOrder;
    vm.canDeleteArticleFromOrder = canDeleteArticleFromOrder;
    vm.canUpdateWholeRow = canUpdateWholeRow;
    vm.updateWholeRow = updateWholeRow;
    vm.getProductGrossPriceSum = getProductGrossPriceSum;
    vm.getVariantGrossPriceAverage = getVariantGrossPriceAverage;

    function onInit() {
        if (vm.resellerOrder.lineItems === undefined) {
            vm.resellerOrder.lineItems = [];
        } else {
            regroupLineItemsOnArticle();
        }

        $scope.$watch(function () { return vm.resellerOrder.lineItems.length; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                regroupLineItemsOnArticle();
            }
        });
    }
    function onChanges() {
    }
    function onDestroy() {
    }

    function getVariantGrossPriceAverage(variant) {
        var sumPrice = 0, sumTotalQuantity = 0;
        sumPrice += _.sumBy(variant.lineItems, function(li) {
            sumTotalQuantity += li.quantity;
            return li.amount * li.quantity;
        });
        return sumPrice / (sumTotalQuantity === 0 ? 1 : sumTotalQuantity);
    }

    function getProductGrossPriceSum(article) {
        var sumPrice = 0;
        _.forEach(article.lineItemsGroupedOnVariant1, function(liGrp) {
            sumPrice += _.sumBy(liGrp.lineItems, function(li) {
                return li.amount * li.quantity;
            });
        });
        return sumPrice;
    }

    function removeArticleFromOrder(article) {
        if (!article || !article.lineItemsGroupedOnVariant1) { return false; }

        confirmationDialogService.showDialog($translate.instant("resellerorder.confirmRemoveArticle"), 'warning').then(function (result) {
            if (result === true) {
                _.forEach(article.lineItemsGroupedOnVariant1, function(variant1) {
                    _.forEach(variant1.lineItems, function(li) {
                        if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                            li.amount = 0;
                            vm.onLineItemChanged({ lineItem: li });
                        }
                    });
                });
                vm.resellerOrder.lineItems = _.filter(vm.resellerOrder.lineItems, function(o) {
                    return o.articleId !== parseInt(article.article.id);
                });
            }
        });
    }
    function canDeleteArticleFromOrder(lineItemsGroupedOnVariant1) {
        if (!lineItemsGroupedOnVariant1) { return false; }

        var canDelete = true;
        _.forEach(lineItemsGroupedOnVariant1, function(variant1) {
            _.forEach(variant1.lineItems, function(li) {
                if (_.find(li.links, function(l) { return l.rel === 'delete'; }) === undefined) {
                    canDelete = false;
                }
            });
        });
        return canDelete;
    }

    function canClearRow(variant1) {
        var canUpdateWholeRow = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;
        return canUpdateWholeRow;

        //TODO look on each lineitem if able to upsert
    }

    function confirmClearRow(lineItemsGroupedOnVariant1) {
        confirmationDialogService.showDialog($translate.instant("resellerorder.confirmClearRow"), 'warning').then(function (result) {
            if (result === true) {
                _.forEach(lineItemsGroupedOnVariant1.lineItems, function(li) {
                    if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                        li.amount = 0;
                        vm.onLineItemChanged({ lineItem: li });
                    }
                });
                lineItemsGroupedOnVariant1.wholeRowAmount = '';
            }
        });
    }

    function canUpdateWholeRow(variant1) {
        var canUpdateWholeRow = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;
        return canUpdateWholeRow;

        //TODO look on each lineitem if able to upsert
    }

    function updateWholeRow(variant1, wholeRowAmount) {
        if (!variant1) { return; }
        if (!variant1.lineItems) { return; }
        if (!wholeRowAmount || wholeRowAmount === '') { return; }

        var lineItem = _.find(variant1.lineItems, function(o) { return o.amount > 0; });
        if (lineItem !== undefined) {
            confirmationDialogService.showDialog($translate.instant('resellerorder.confirmUpdateWholeRow'), $translate.instant('common.warning')).then(function (result) {
                if (result === true) {
                    _.forEach(variant1.lineItems, function(li) {
                        if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                            li.amount = wholeRowAmount;
                            vm.onLineItemChanged({ lineItem: li });
                        }
                    });
                }
                variant1.wholeRowAmount = '';
            });
        } else {
            _.forEach(variant1.lineItems, function(li) {
                if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                    li.amount = wholeRowAmount;
                    vm.onLineItemChanged({ lineItem: li });
                }
            });
            variant1.wholeRowAmount = '';
        }
    }

    function toggleExpandAll() {
        var allAreExpanded = true;
        _.forEach(vm.lineItemsGroupedByArticle, function (o) {
            if (!o.article.showRows || o.article.showRows === false) {
                allAreExpanded = false;
            }
        });

        _.forEach(vm.lineItemsGroupedByArticle, function(art) {
            if (!allAreExpanded) {
                art.article.showRows = true;
            } else {
                art.article.showRows = false;
            }
        });
    }

    function getVariant1s(lineItems) {
        var variants = _.chain(lineItems)
            .groupBy('variantDetail1Name')
            .map((value, key) => ({ variantDetail1Name: key, lineItems: value }))
            .value();

        return variants;
    }
    function getVariant2s(lineItems) {
        var variants = _.map(lineItems, 'variantDetail2Name');

        return variants;
    }

    function canModifyLineItem(lineItem) {
        var canModifyLineItems = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;
        return canModifyLineItems;

        //TODO look on each lineitem if able to upsert
        // if (lineItem === undefined) { return false; }
        // if (!lineItem.links) { lineItem.links = []; }
        // var canModifyLineItem = _.find(lineItem.links, function(o) { return o.rel === 'modify'; }) !== undefined;

        // return canModifyLineItem;
    }

    function regroupLineItemsOnArticle() {
        vm.resellerOrder.lineItems = _.sortBy(vm.resellerOrder.lineItems, ['variantDetail1Name', 'variantDetail2SortOrder']);
        vm.lineItemsGroupedByArticle = _.chain(vm.resellerOrder.lineItems)
            // Group the elements of Array based on `color` property
            .groupBy('articleId')
            // `key` is group's name (color), `value` is the array of objects
            .map((value, key) => ({
                article: {
                    displayArticleNumber: value.length > 0 ? value[0].displayArticleNumber : '',
                    articleName: value.length > 0 ? value[0].articleName : '',
                    id: key,
                    showRows: false
                }, lineItemsGroupedOnVariant1: regroupLineItemsOnVariant1(value) }))
            .value();
    }
    function regroupLineItemsOnVariant1(lineItems) {
        var lineItemsGroupedByVariant1 = _.chain(lineItems)
            .groupBy('variantDetail1Name')
            .map((value, key) => ({
                variantDetail1Name: key,
                lineItems: value
            }))
            .value();
        return lineItemsGroupedByVariant1;
    }

    function groupBy(array, field) {
        return _.groupBy(array, field);
    }

    function saveLineItem(lineItem) {
        vm.onLineItemChanged({ lineItem: lineItem });
    }

    function viewOrderArticle(article) {
        vm.onArticleSelected({ article: article });
    }

    function absolute(number) {
        if (_.isNumber(number)) {
            return Math.abs(number);
        }
        return 0;
    }
}
